import { Typography, ListItemText } from '@mui/material';
import List from '../styled/List';
import ListItemIcon from '../styled/ListItemIcon';
import ListItem from '../styled/ListItem';

const TechnicalRequirementsAndLiveChat = () => (
  <>
    <Typography variant="h5" fontWeight="700" textTransform="none">
      5A. Warunki techniczne oraz zasady korzystania z usługi oferowanej w
      ramach kanału komunikacji Chat/Chatbot
    </Typography>
    <List>
      <ListItem>
        <ListItemIcon>5.1.</ListItemIcon>
        <ListItemText>
          Chat to cyfrowy kanał komunikacji, który umożliwia interakcję
          Administratora z Użytkownikami w czasie rzeczywistym za pośrednictwem
          wiadomości tekstowych wysyłanych przez pracownika Administratora.
        </ListItemText>
      </ListItem>
      <ListItem>
        <ListItemIcon>5.2.</ListItemIcon>
        <ListItemText>
          ChatBot to usługa polegająca na prowadzeniu rozmów z Użytkownikami za
          pomocą wiadomości tekstowych na czacie. Jego głównym zadaniem jest
          pomaganie Użytkownikom poprzez udzielanie odpowiedzi, mających
          charakter informacyjno - instruktażowy.
        </ListItemText>
      </ListItem>
      <ListItem>
        <ListItemIcon>5.3.</ListItemIcon>
        <ListItemText>
          Korzystanie z usługi Chata/ChatBota jest bezpłatne.
        </ListItemText>
      </ListItem>
      <ListItem>
        <ListItemIcon>5.4.</ListItemIcon>
        <ListItemText>
          Do korzystania z usługi Chata/ChatBota niezbędny jest dostęp
          Użytkownika do zasobów sieci Internet, a także możliwość korzystania z
          jednej z wymienionych przeglądarek internetowych: Google Chrome,
          Mozilla Firefox, Opera, Internet Explorer lub Safari.
        </ListItemText>
      </ListItem>
      <ListItem>
        <ListItemIcon>5.5.</ListItemIcon>
        <ListItemText>
          Przy korzystaniu z usługi Chata/ChatBota zaleca się, aby Użytkownik
          posiadał zaktualizowane oprogramowanie antywirusowe.
        </ListItemText>
      </ListItem>
      <ListItem>
        <ListItemIcon>5.6.</ListItemIcon>
        <ListItemText>
          Za pośrednictwem usługi Chata Administrator zapewnia dostęp do
          bieżących informacji w sprawach dotyczących Użytkownika lub podmiotu,
          w którego imieniu Użytkownik działa oraz do ogólnodostępnych
          informacji dotyczących Administratora.
        </ListItemText>
      </ListItem>
      <ListItem>
        <ListItemIcon>5.7.</ListItemIcon>
        <ListItemText>
          Użytkownik zobowiązuje się podczas korzystania z usługi Chata/ChatBota
          do przestrzegania prawa obowiązującego na terenie Rzeczypospolitej
          Polskiej oraz postanowień niniejszego Regulaminu.
        </ListItemText>
      </ListItem>
      <ListItem>
        <ListItemIcon>5.8.</ListItemIcon>
        <ListItemText>
          Dane osobowe Użytkowników są chronione zgodne z obowiązującymi
          przepisami prawa poprzez zabezpieczenia techniczne i elektroniczne,
          polegające m.in. na szyfrowaniu połączeń ze stronami internetowymi, na
          których usługa jest udostępniana za pomocą protokołu SSL oraz
          rygorystyczne procedury, zapobiegające przed dostępem do danych
          osobowych Użytkowników przez osoby nieuprawnione.
        </ListItemText>
      </ListItem>
      <ListItem>
        <ListItemIcon>5.9.</ListItemIcon>
        <ListItemText>
          Użytkownik jest uprawniony do uzyskania za pośrednictwem usługi Chata
          informacji nt. swoich spraw będących w obsłudze podmiotu BEST S.A.
        </ListItemText>
      </ListItem>
      <ListItem>
        <ListItemIcon>5.10.</ListItemIcon>
        <ListItemText>
          Rozmowy prowadzone przez Użytkownika w ramach usługi Chata/ChatBota
          powinny dotyczyć wyłącznie spraw będących w bieżącej obsłudze podmiotu
          BEST S.A. lub dotyczyć ogólnodostępnych informacji związanych z BEST
          S.A.
        </ListItemText>
      </ListItem>
      <ListItem>
        <ListItemIcon>5.11.</ListItemIcon>
        <ListItemText>
          Zakazane są działania i zachowania Użytkowników korzystających z
          usługi Chata/ChatBota mające charakter bezprawny, w tym w
          szczególności noszące znamiona wykroczenia lub przestępstwa,
          określonych w bezwzględnie obowiązujących przepisach prawa, w
          szczególności w ustawie z dnia 6 czerwca 1997 r. Kodeks karny lub w
          ustawie z dnia 20 maja 1971 r. Kodeks wykroczeń.
        </ListItemText>
      </ListItem>
      <ListItem>
        <ListItemIcon>5.12.</ListItemIcon>
        <ListItemText>
          Użytkownik może w każdej chwili zrezygnować z korzystania z usługi
          Chata/ChatBota.
        </ListItemText>
      </ListItem>
      <ListItem>
        <ListItemIcon>5.13.</ListItemIcon>
        <ListItemText>
          Rozmowa realizowana za pośrednictwem Chata jest natychmiastowo
          przerywana, jeżeli wystąpi którakolwiek z poniższych okoliczności:
          <List>
            <ListItem>
              <ListItemIcon>a)</ListItemIcon>
              <ListItemText>
                charakter rozmowy nie ma związku lub wykroczy poza zakres
                wskazany w ustępie,
              </ListItemText>
            </ListItem>
            <ListItem>
              <ListItemIcon>b) </ListItemIcon>
              <ListItemText>
                zachowanie Użytkownika nosi znamiona wykroczenia lub
                przestępstwa,
              </ListItemText>
            </ListItem>
            <ListItem>
              <ListItemIcon>c) </ListItemIcon>
              <ListItemText>
                zachowanie Użytkownika jest sprzeczne z przepisami prawa lub
                zasadami współżycia społecznego.
              </ListItemText>
            </ListItem>
          </List>
        </ListItemText>
      </ListItem>
      <ListItem>
        <ListItemIcon>5.14.</ListItemIcon>
        <ListItemText>
          Administrator przestrzega przed nieuprawnionym rozpowszechnianiem
          treści rozmów.
        </ListItemText>
      </ListItem>
      <ListItem>
        <ListItemIcon>5.15.</ListItemIcon>
        <ListItemText>
          W trosce o wysoką jakość oraz bezpieczeństwo świadczonych usług, każda
          rozmowa za pośrednictwem Chata/ChatBota jest rejestrowana na serwerach
          komputerowych w formie zapisu czatu w bazie danych. Rozpoczęcie
          rozmowy w ramach Chata/ChatBota jest jednoznaczne z wyrażeniem zgody
          na rejestrowanie rozmowy.
        </ListItemText>
      </ListItem>
      <ListItem>
        <ListItemIcon>5.16.</ListItemIcon>
        <ListItemText>
          Administrator Usługi może w każdym momencie rozszerzyć, zmienić,
          ograniczyć lub zaprzestać oferowania Użytkownikowi niektórych
          funkcjonalności, jak i całości usługi Chata/ChatBota.
        </ListItemText>
      </ListItem>
    </List>
  </>
);

export default TechnicalRequirementsAndLiveChat;
